import React from 'react';
import './LayoutCustomizationModal.css';

function LayoutCustomizationModal({
  isOpen,
  onClose,
  layoutSettings,
  onLayoutChange,
  previewComponent,
}) {
  if (!isOpen) return null;

  const handleChange = (setting, value) => {
    onLayoutChange({ ...layoutSettings, [setting]: value });
  };

  return (
    <div className="layout-modal-overlay" onClick={onClose}>
      <div className="layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="layout-modal-header">
          <h2>Customize Layout</h2>
          <button className="layout-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="layout-modal-content">
          {/* Left Side - Controls */}
          <div className="layout-controls">
            <div className="control-section">
              <h3>Layout Positioning</h3>
              
              <div className="control-group">
                <label>Logo Position</label>
                <select
                  value={layoutSettings.logoPosition}
                  onChange={(e) => handleChange('logoPosition', e.target.value)}
                >
                  <option value="top-left">Top Left</option>
                  <option value="top-right">Top Right</option>
                  <option value="bottom-left">Bottom Left</option>
                  <option value="bottom-right">Bottom Right</option>
                </select>
              </div>

              <div className="control-group">
                <label>Info Box Position</label>
                <select
                  value={layoutSettings.infoPosition}
                  onChange={(e) => handleChange('infoPosition', e.target.value)}
                >
                  <option value="left">Left Side</option>
                  <option value="right">Right Side</option>
                </select>
              </div>

              <div className="control-group">
                <label>Year Display</label>
                <select
                  value={layoutSettings.yearPosition}
                  onChange={(e) => handleChange('yearPosition', e.target.value)}
                >
                  <option value="top-left">Top Left</option>
                  <option value="top-right">Top Right</option>
                  <option value="bottom-left">Bottom Left</option>
                  <option value="bottom-right">Bottom Right</option>
                  <option value="hidden">Hidden</option>
                </select>
              </div>

              <div className="control-group">
                <label>TRYOUTS Opacity</label>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={layoutSettings.tryoutsOpacity * 100}
                  onChange={(e) =>
                    handleChange('tryoutsOpacity', e.target.value / 100)
                  }
                />
                <span className="opacity-value">
                  {Math.round(layoutSettings.tryoutsOpacity * 100)}%
                </span>
              </div>
            </div>

            <div className="control-section">
              <h3>Typography</h3>
              
              <div className="control-group">
                <label>Text Treatment</label>
                <select
                  value={layoutSettings.textTreatment}
                  onChange={(e) => handleChange('textTreatment', e.target.value)}
                >
                  <option value="shadow">Strong Shadow</option>
                  <option value="box">Dark Box Behind</option>
                  <option value="stroke">Text Stroke</option>
                </select>
              </div>
            </div>
          </div>

          {/* Right Side - Live Preview */}
          <div className="layout-preview">
            <div className="preview-label">Live Preview</div>
            <div className="preview-wrapper">{previewComponent}</div>
          </div>
        </div>

        <div className="layout-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={onClose}>
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default LayoutCustomizationModal;